module.exports = __webpack_public_path__ + "img/about-image.326022a8.jpg";